import { render, staticRenderFns } from "./54.vue?vue&type=template&id=00fbe43b&scoped=true&"
var script = {}
import style0 from "./54.vue?vue&type=style&index=0&id=00fbe43b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00fbe43b",
  null
  
)

export default component.exports